import { useEffect, useState } from 'react'

function useHasMounted() {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  return mounted
}

export default useHasMounted
